const third_places = [
  {
    places: 'Willard Park',
    reason: "I live right down the street from it, so every time I'm leaving or coming home, I bike past and run into friends there. It feels like the center of the universe. My favorite memory from Willard was when I was hanging out there and ran into friends who invited me to a pickup soccer game happening there. I joined and now we play all the time. #FCWILLARD",
    lat: 37.86121978,
    long: -122.2566417,
  },
  {
    places: 'The Walkway By Haas Pavilion That Connects Blackwell And Vlsb',
    reason: "It's a very relaxing part of my walk to class that is not too busy, but you always see interesting people. It's also a great place to sit when you get a little free time between classes because there are a lot of benches that the sun warms up just the right amount. I have a lot of great memories there, especially walking through there at 11 PM after club tennis practice and seeing the 10 different hip-hop dancing groups grinding their routines there.",
    lat: 37.870485,
    long: -122.262134,
  },
  {
    places: 'The Benches Outside Of Dwinelle',
    reason: "It's where I've done last-minute studying, cried on the phone to my mom, or just listened to music and taken in the beautiful day. I tend to run into current and old class friends there and love feeling connected to them!",
    lat: 37.87054885,
    long: -122.2605929,
  },
  {
    places: 'Observatory Hill',
    reason: "Flowers grow in there in the spring---tulips, sunflowers, poppies, and all sorts of other plants and insects spring up about the area. I would fall asleep beneath the trees in the greener patches of grass in between classes and wake up warm. Only con(?) is I've had squirrels jump on my head twice. They are ALWAYS out to get me",
    lat: 37.87441758,
    long: -122.2603457,
  },
  {
    places: 'Elmwood Rialto',
    reason: 'I love going there with my friends and watching a movie together with strangers. It’s a very unifying and unique experience that I’m glad still exists. Seeing a movie that’s packed with people changes the whole dynamic and makes it so much more enjoyable.',
    lat: 37.85677934,
    long: -122.2531539,
  },
  {
    places: 'Memorial Glade',
    reason: "I like Memorial Glade because I've hung out with friends to play spikeball and volleyball. My favorite memory was playing volleyball with my GBO group and taking a nap on the glade during GBO.",
    lat: 37.873178,
    long: -122.2593595,
  },
  {
    places: 'Small Amphitheater To The Right Of Sather Gate',
    reason: 'There is a small amphitheater to the right of sather gate, right in front of strawberry creek. Its right next to Sproul and Sather Rd so its a good place for a quick stoppage during the day.',
    lat: 37.86957699,
    long: -122.2595028,
  },
  {
    places: 'Binge Coffee',
    reason: 'Not only is it a great study spot but i also have some amazing memories bonding with my roomate there.',
    lat: 37.86796593,
    long: -122.2662173,
  },
  {
    places: 'A Little Wood On The Right Of Sather Gate',
    reason: "When you walk up just a little bit, you'd be able to see the campanile behind wheeler's hall, embedded under the treetops",
    lat: 37.87047085,
    long: -122.2590749,
  },
  {
    places: 'Willard Park',
    reason: "This past summer, I met a bunch of new friends after I started playing pickup soccer with them. We'd play a few times a week, and still play during the school year, and seeing everyone there is always the highlight of my week.",
    lat: 37.86106028,
    long: -122.2565027,
  },
  {
    places: 'The Glade',
    reason: 'Simply iconic',
    lat: 37.87315474,
    long: -122.259381,
  },
  {
    places: 'Eliachi',
    reason: "Both my parents were born and raised in Pakistan. I am an out-of-state student, so Eliachi in everything from its decor, community, and chai offers me a small slice of home every time I go by. Being so far, it's easy to feel a bit disconnected from my culture and Eliachi makes it a little easier to remember my roots.",
    lat: 37.86969558,
    long: -122.2665345,
  },
  {
    places: 'Berkeley Marina',
    reason: 'I like to kayak there every weekend, and have been doing so since I was a freshman. Sometimes I take my readings down there and sit at the waterfront. I’ll pick blackberries and watch the tide go out.',
    lat: 37.8663509,
    long: -122.3150413,
  },
  {
    places: "Mrs. Dalloway'S Bookstore",
    reason: 'When I was a freshman, I would walk from Clark Kerr to Elmwood to clear my head, and I would stumble into their store. I always loved chatting with the workers about books and supporting an independent bookstore.',
    lat: 37.85815948,
    long: -122.2532915,
  },
  {
    places: 'Strawberry Creek Park',
    reason: "I'm a first year, but I think I've started to love Strawberry Creek Park to the point that I'm sick of it. I've walked there 7 or 8 times in the past three weeks. Sometimes I do my homework, but I always love to people watch.",
    lat: 37.8670643,
    long: -122.2862067,
  },
  {
    places: 'Edmonds Cafe',
    reason: 'As a chill breaches the air at Berkeley, few ways are better than the Hazy IPA at Edmonds Happy Hour.',
    lat: 37.86981482,
    long: -122.2514581,
  },
  {
    places: 'The Eucalyptus Grove',
    reason: 'The eucalyptus grove is honestly the first place i go when i need to just be outside. Last year when me and my roommates were all processing a moment of grief we talked it out there so we could get out of our god forsaken building',
    lat: 37.8714564,
    long: -122.2640526,
  },
  {
    places: 'Edmonds Cafe',
    reason: 'It provides a quaint and comfortable outdoor seating area to have a coffee, drink beer, or socialize with my friends all of whom are so busy and preoccupied doing whatever it is people do during the week that I never get to see them.',
    lat: 37.86981482,
    long: -122.2514581,
  },
  {
    places: 'The Long Cement Bench At The Bottom Of The Steps To The Campanile Facing The Bay',
    reason: 'It always offer a poignant moment of reflection and sometimes a jovial conversation with a passerby.',
    lat: 37.87210498,
    long: -122.25785,
  },
  {
    places: 'Moffitt Library',
    reason: 'It is an area of campus where I can go to study/finish homework, hang out with friends while drinking coffee or eating food, and enjoy views of campus. I enjoy getting to Moffitt early in the morning, sitting by the window and admiring the stunning views of the Glade, Campanile, and University Library from the 4th & 5th floors. The other floors also hold special memories; floor one is a place I got to for late night study sessions, while the booth seating on floor 3 by Main Stacks is a favorite weekend spot for me and my floor mates. Overall, Moffitt has become a place of comfort for me: it’s a place where I can start my day feeling energized, while also being a place I can unwind after a busy day.',
    lat: 37.87253267,
    long: -122.2608473,
  },
  {
    places: 'Foothill Dining Hall',
    reason: 'Despite my identity here on campus as a brand new freshman and someone still learning the difference between Northside and Southside, Foothill dining has quickly become my third space. Here, everyone is a familiar face, and each long, wooden table is temporarily home to someone I can sit and chat with. Through this third place alone, I have met some of my favorite familiar faces and established a home away from home.',
    lat: 37.87540476,
    long: -122.2561309,
  },
  {
    places: 'The Student Cooperative Housing',
    reason: "Parties feel inviting, cheap, and safe. I love being carried around on a drunk girl's back at a band night with a niche theme.",
    lat: 37.87576228,
    long: -122.261206,
  },
  {
    places: 'The Running Track At Edwards Stadium',
    reason: "It's somewhere where people can gather with the shared intent to better themselves and work towards hard goals alongside each other, and that feels pretty special when you get to be a part of it.",
    lat: 37.86894375,
    long: -122.2648802,
  },
  {
    places: 'Games Of Berkeley',
    reason: " I love playing games with my friends there, participating in events, and getting to know people. It's fun to know that there's a common interest which I share with everyone there.",
    lat: 37.86754599,
    long: -122.2583682,
  },
  {
    places: 'Indian Rock Park',
    reason: 'The best place to watch the sunset in Berkeley and its not too far, just a short bus away and a nice walk back. I have had some of my best, deepest conversations with my friends, watching the sun slowly dip - and there are always kids and famalies running around, all enjoying the view.',
    lat: 37.89218424,
    long: -122.2726948,
  },
  {
    places: 'The Glade ',
    reason: 'The best place to watch dogs run around, join people to play volleyball, or just bask in the sun!',
    lat: 37.87315474,
    long: -122.259381,
  },
  {
    places: 1951,
    reason: "Have outdoor and indoor seating and they give their pastries out for free if they haven't sold them. and all going to a good cause.",
    lat: 37.86661813,
    long: -122.2599663,
  },
  {
    places: 'Cafe Strada ',
    reason: 'Cafe Strada for feeling the cafe community vibe!',
    lat: 37.86911947,
    long: -122.2548513,
  },
  {
    places: 'Memorial Pool',
    reason: 'I love sitting down on the edge after walking around campus for a bit to talk to friends and catch up.',
    lat: 37.87306238,
    long: -122.2602165,
  },
  {
    places: 'Uc Berkeley Recreation And Wellbeing',
    reason: 'Going to the gym and hitting a workout with music would be my favorite third space that I spend a lot of time. It helps me to forget about everything but also allow me to deeply focus in one thing.',
    lat: 37.8710027,
    long: -122.251926,
  },
];

export { third_places };
